module.exports = __webpack_public_path__ + "static/img/not001.2b2c0e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/not001.png
// module id = UnFd
// module chunks = 3